import Bloc from './Bloc.js';
import Types from './Types.js';

export default class LoseGold extends Bloc {

	constructor (src, ctx) {

		super("losegold", src, ctx, true);
		this.f = (src, ins) => {
			src.master.run.champion.loseGold(ins[0]);
			return [];
		};
		this.types = [Types.int];
	}
}